let STRIPE_BASE_URL: string;

// eslint-disable-next-line no-undef
if (process.env.REACT_APP_ENV === "production")
  STRIPE_BASE_URL = "https://dashboard.stripe.com/";
else {
  STRIPE_BASE_URL = "https://dashboard.stripe.com/test/";
}

export { STRIPE_BASE_URL };